export const setPageLanguage = (language: string) => {
  document?.querySelector('html')?.setAttribute('lang', language);
};
